
//BrowserRouter
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';


import Home from '@/views/home';
import List from '@/views/list';
import Past from '@/views/past';
import Cost from '@/views/cost';

export default function() {
  return (
    <Router>
      <Switch>
      {/* <Route path='/home' component={Home}/>
        <Route path='/list' component={List}/>
        <Route path='/past' component={Past}/>
        <Route path='/cost' component={Cost}/>
        <Redirect from='*' to='/list'/> */}
        <Route path='/release/bbf/home' component={Home}/>
        <Route path='/release/bbf/list' component={List}/>
        <Route path='/release/bbf/past' component={Past}/>
        <Route path='/release/bbf/cost' component={Cost}/>
        <Redirect from='*' to='/release/bbf/list'/>
      </Switch>
    </Router>
  )
}

